// Personal/HR staff fields that live in staffPrivate/{users|staff}/{id}, NOT on the
// users/ or staff/ records (which every staff login can read). Must match
// server/lib/staffPrivate.js — privateFields.test.js holds them together.
export const PRIVATE_FIELDS = Object.freeze([
  'aadhaarNumber', 'panNumber', 'pfNumber', 'esiNumber',
  'bankName', 'branchName', 'accountNumber', 'ifscCode',
  'emergencyContact1', 'emergencyContact2',
  'address', 'bloodGroup', 'birthday', 'dob',
  'wageType', 'defaultRate',
]);

// Roles that may read and edit other people's private fields (rules enforce this too).
export const HR_ROLES = Object.freeze(['super_admin', 'admin']);
export const isHrRole = (role) => HR_ROLES.includes(String(role || '').toLowerCase());

export const withoutPrivate = (obj) => Object.fromEntries(
  Object.entries(obj || {}).filter(([k]) => !PRIVATE_FIELDS.includes(k)),
);
